import { userService } from "../services/user.service";
import { appConstants } from "../helpers/constants";
import currency from "../helpers/currencies.json";

// import CryptoJS from 'crypto-js';
// const SECRET_KEY = 'thequickdonckeyjumpsoverthelazydog'; 

// import { history } from "../helpers/history";

export const userActions = {
  loginRequest,
  logoutRequest,
  updateUserData,
  updateCurrency,
  loginUser,
  updateUserSettings,
};

// var CryptoJSAesJson = {
//   stringify: function (cipherParams) {
//       var j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};
//       if (cipherParams.iv) j.iv = cipherParams.iv.toString();
//       if (cipherParams.salt) j.s = cipherParams.salt.toString();
//       return JSON.stringify(j);
//   },
//   parse: function (jsonStr) {
//       var j = JSON.parse(jsonStr);
//       var cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});
//       if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
//       if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
//       return cipherParams;
//   }
// }

// function encryptData(data){
//   const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY, {format: CryptoJSAesJson}).toString();
//   return encrypted;
// }

function loginRequest(obj) {
  return (dispatch, getState) => {
    dispatch({
      type: appConstants.REQUESTING_LOGIN,
    });
    userService.loginUser(obj).then(
      (response) => {
        if(response.data.status == 200){
          const id = response.data.result.id.slice(5);
          localStorage.setItem('user_text_obj_data1', userService.encryptData(id,'crypto'));
          localStorage.setItem('user_text_obj_data2', userService.encryptData(response.data.result.full_name,'base64'));
          localStorage.setItem('items_text_obj', userService.encryptData(response.data.result.item_sorting,'base64'));
          
          localStorage.setItem('monthStartDate', response.data.result.month_start_date);
          // fetch currency sign...
          const foundCurrency = currency.find(element => element.code == response.data.result.currency);
          localStorage.setItem('currency', foundCurrency.symbol);
          let obj = {
            id: response.data.result.id,
            default_budget: response.data.result.default_budget
          }
          dispatch({
            type: appConstants.UPDATE_LOGIN_STATUS,
            isLoggedIn: true,
            loggedInData: obj,
            currency: foundCurrency.symbol
          });
        }
        else {
          alert(response.data.message);
          dispatch({
            isLoggedIn: false,
            type: appConstants.LOGIN_ERROR,
            message: response.data.message,
          });  
        }
        
      },
      (error) => {
        dispatch({
          type: appConstants.LOGIN_ERROR,
          error,
        });
      }
    ).catch(err=>{
      dispatch({
        type: appConstants.LOGIN_ERROR,
        err,
      });
  });
  };
}

function loginUser(userObj) {
  const id = userObj.id.slice(5);
  localStorage.setItem('user_text_obj_data1', userService.encryptData(id,'crypto'));
  localStorage.setItem('user_text_obj_data2', userService.encryptData(userObj.full_name,'base64'));
  localStorage.setItem('items_text_obj', userService.encryptData(userObj.item_sorting,'base64'));
  if(userObj.hide_income == 1){
    localStorage.setItem('items_text_obj2', userObj.hide_income);
  }
  
  localStorage.setItem('monthStartDate', userObj.month_start_date);
  // fetch currency sign...
  const foundCurrency = currency.find(element => element.code == userObj.currency);
  localStorage.setItem('currency', foundCurrency.symbol);

  return (dispatch, getState) => {
    let obj = {
      id: userObj.id,
      default_budget: userObj.default_budget
    }
    dispatch({
      type: appConstants.UPDATE_LOGIN_STATUS,
      isLoggedIn: true,
      loggedInData: obj,
      currency: foundCurrency.symbol
    });

  };
}

// Logout Request
function logoutRequest(){
  return (dispatch, getState) => {
    dispatch({
      type: appConstants.UPDATE_LOGIN_STATUS,
      isLoggedIn: false,
      loggedInData: null,
    });

  };
}

function updateUserData(){
  return (dispatch, getState) => {
    const user_text_obj_data1 = localStorage.getItem('user_text_obj_data1');
    if(user_text_obj_data1){
      const currencySymbol = localStorage.getItem('currency');
      const hideIncome = localStorage.getItem('items_text_obj2') ? true : false;
      dispatch({
        type: appConstants.UPDATE_USER_STATUS,
        isLoggedIn: true,
        //loggedInData: {id: localStorage.getItem('user_text_obj_data1'), default_budget:0},
        currency: currencySymbol,
        hideIncome: hideIncome
      });  
    }
  };
}

function updateCurrency(obj){
  return (dispatch, getState) => {
    dispatch({
      type: appConstants.UPDATE_CURRENCY,
      currency: obj.currency
    });  
  };
}

function updateUserSettings(obj){
  return (dispatch, getState) => {
    dispatch({
      type: appConstants.UPDATE_USER_SETTINGS,
      hideIncome: obj.hideIncome,
    });  
  };
}


// const deleteItem = () => {
//   return {
//     type: DELETE_ITEM,
//   };
// };
